import store from "@frameworks/web/redux/store";
import { UNBLOCK_USER, UNBLOCK_USER_ERROR, UNBLOCK_USER_HIDE_ERROR, UNBLOCK_USER_START_LOADER, UNBLOCK_USER_STOP_LOADER, } from "../interface/iUnblockUser";
class UnblockUserActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    unblockUser(data) {
        this.dispatch({
            type: UNBLOCK_USER,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: UNBLOCK_USER_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: UNBLOCK_USER_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: UNBLOCK_USER_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: UNBLOCK_USER_STOP_LOADER,
        });
    }
}
export default UnblockUserActions;
